import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClarity = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 2C8.268 2 2 8.268 2 16C2 23.732 8.268 30 16 30C19.878 30 23.389 28.424 25.925 25.878L21.682 21.636C20.228 23.097 18.218 24 16 24C11.582 24 8 20.418 8 16C8 11.582 11.582 8 16 8C20.418 8 24 11.582 24 16H30C30 8.268 23.732 2 16 2Z",
		fill: "#2B88D8"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 16,
		cy: 16,
		r: 4,
		fill: "#6AB8F2"
	})]
});
export default SvgClarity;
